import { render, staticRenderFns } from "./InpatientReviewDialog.vue?vue&type=template&id=b29f98fc&"
import script from "./InpatientReviewDialog.vue?vue&type=script&lang=js&"
export * from "./InpatientReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./InpatientReviewDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports